import intl from "react-intl-universal";

export const getAuthorStatus = (user, status) =>
  status || (user?.uuid || user?.username ? "ACTIVE" : "MISSING");

export const getAuthorName = (user, status) => {
  const state = getAuthorStatus(user, status);
  if (state === "DELETED") return intl.get("Share.Deleted user");
  if (state !== "ACTIVE") return intl.get("Share.Unknown user");
  return user?.nickname || user?.username || intl.get("Share.Unknown user");
};

export const canDeleteComment = (comment, currentUser) => {
  if (comment.commentStatus === "DELETED" || getAuthorStatus(comment.user, comment.authorStatus) !== "ACTIVE") return false;
  if (currentUser?.uuid && comment.user?.uuid) return currentUser.uuid === comment.user.uuid;
  return Boolean(currentUser?.username && currentUser.username === comment.user?.username);
};

export default function CommentAuthor({ user, status }) {
  const name = getAuthorName(user, status);
  if (getAuthorStatus(user, status) !== "ACTIVE" || !user?.uuid) return <span>{name}</span>;
  return <a href={`${process.env.PUBLIC_URL || ""}/user?uuid=${encodeURIComponent(user.uuid)}`}>{name}</a>;
}
